/* Заголовок вкладки под текущий экран. */
import { useEffect } from 'react';

const SUFFIX = 'SAINTS.';

export function useTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} · ${SUFFIX}` : `${SUFFIX} — мерч-магазин`;
  }, [title]);
}

export default useTitle;
